export default (app) => {
  app.directive('loadmore', {
    mounted(el, binding) {
      const child = el.querySelector('.select-trigger');
      const id = child.getAttribute('aria-describedby');
      const poper = document.getElementById(id);
      const SELECTDOWN_DOM = poper.querySelector('.el-scrollbar .el-select-dropdown__wrap');
      SELECTDOWN_DOM.addEventListener('scroll', function () {
        const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (CONDITION) {
          binding.value();
        }
      });
    },
  }),
    app.directive('removeAriaHidden', {
      bind(el, binding) {
        let ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach((item) => {
          item.removeAttribute('aria-hidden');
        });
      }
    });
}
